export const initialStratsSidebarData = {
  edgarFilingUrl: '',
  dataTapeUrl: '',
  displayButtonDownloadRelDoc: false,
  dataTapeRelatedDocumentUrl: '',
  dataTapeRelatedDocumentType: '',
};

export const initialPopoverData = {
  currentTriggerComponentId: null,
  offsetTop: 0,
  offsetLeft: 0,
};

export const initialStratsMetaData = {
  filingTitle: '',
  absAssetClass: '',
  totals: [],
  columns: {},
};
